import React from 'react';
import { Flex, Heading, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { MerchantsTab } from './components/MerchantsTab';
import { BranchesTab } from './components/BranchesTab';

export const AuditorMerchants = () => {

  return (
    <Flex flexDirection="column" height="100%" overflow="hidden">
      <Heading as="h2" fontSize="xl">Mi comercio</Heading>

      <Tabs display="flex" overflow="hidden" flexDirection="column" flexGrow="1" marginTop="xxl" colorScheme="orange" isLazy>
        <TabList flexWrap="wrap" flexShrink="0" backgroundColor="white">
          <Tab whiteSpace="nowrap">Comercios</Tab>
          <Tab whiteSpace="nowrap">Sucursales asociadas</Tab>
        </TabList>

        <TabPanels flexGrow="1" minHeight="0" overflowY="auto">
          <TabPanel height="100%">
            <MerchantsTab />
          </TabPanel>
          <TabPanel height="100%">
            <BranchesTab />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Flex>
  );
};
